import React from "react";
import { Box, IconButton, Typography, styled } from "@mui/material";
import { Star as StarIcon, StarBorder as StarBorderIcon } from "@mui/icons-material";

const StyledStarButton = styled(IconButton)({
  padding: 0,
  margin: 0,
  backgroundColor: "transparent",
  border: "none",
});

const RatingBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  border: "1px solid #E0E0E0",
  borderRadius: "8px",
  padding: "6px 12px",
  height: "40px",
  backgroundColor: "#FFFFFF",
  // minWidth: "200px",
  justifyContent: "start",
  gap: "20px"
  // marginRight: "60px"
});

const StarContainer = styled(Box)({
  display: "flex",
  gap: "3px",
  // paddingRight: "12px", // Add some padding before the border
  borderRight: "1px solid #A9BE7B", // Right border added here
  padding: "0 12px 0 0"
});

const getRatingLabel = (rating) => {
  const roundedRating = Math.round(rating);
  switch (roundedRating) {
    case 1:
      return "1: Poor";
    case 2:
      return "2: Below Average";
    case 3:
      return "3: Average";
    case 4:
      return "4: Good";
    case 5:
      return "5: Flawless";
    default:
      return "";
  }
};

const StarRating = ({ service, label, rating, required = false, onRatingChange }) => {
  return (
    <Box sx={{ width: "100%" }}>
      {/* Service Label */}
      <Typography
        sx={{
          font: "AvertaStd-Regular",
          fontSize: "14px",
          fontWeight: 500,
          // color: "#333333",
          marginBottom: "4px",
        }}
      >
        {label}
        {required && <span style={{ color: "#D32F2F" }}> *</span>}
      </Typography>

      {/* Star Rating Box */}
      <RatingBox>
        <StarContainer>
          {[1, 2, 3, 4, 5].map((star) => (
            <StyledStarButton key={star} onClick={() => onRatingChange(service, star)}>
              {star <= rating ? (
                <StarIcon sx={{ color: "#ADB792", fontSize: "18px" }} />
              ) : (
                <StarBorderIcon sx={{ color: "#D1D1D1", fontSize: "18px" }} />
              )}
            </StyledStarButton>
          ))}
        </StarContainer>

        {/* Rating Text */}
        <Typography
          variant="body2"
          sx={{
            color: "#8A9566",
            fontSize: "14px",
            fontWeight: 500,
            paddingLeft: "12px", // Adds space after border
            whiteSpace: "nowrap",
          }}
        >
          {getRatingLabel(rating)}
        </Typography>
      </RatingBox>
    </Box>
  );
};

export default StarRating;
